export const SELECT_ATTACHMENT = "SELECT_ATTACHMENT";
export const UNSELECT_ATTACHMENT = "UNSELECT_ATTACHMENT";

export function selectCurrentAttachment(attachmentId) {
  return {
    type: SELECT_ATTACHMENT,
    attachmentId
  };
}

export function unselectCurrentAttachment() {
  return {
    type: UNSELECT_ATTACHMENT
  };
}
